import React from 'react';
import { Link } from 'react-router-dom';

const ServiceSection = ({data}) => {
    return (
        <div className="container py-5">
            <div
                className="text-center mx-auto mb-5 wow fadeInUp"
                data-wow-delay="0.1s"
                style={{
                    maxWidth: 500,
                    visibility: "visible",
                    animationDelay: "0.1s",
                    animationName: "fadeInUp"
                }}
            >
                <p className="text-primary text-uppercase mb-2">Our Services</p>
                <h1 className="display-6 mb-4">We Provide Best Professional Services</h1>
            </div>
            <div className="row g-3">
                <div
                    className="col-lg-3 col-md-6 wow fadeInUp"
                    data-wow-delay="0.1s"
                    style={{
                        visibility: "visible",
                        animationDelay: "0.1s",
                        animationName: "fadeInUp"
                    }}
                >
                    <div className="service-item d-flex flex-column bg-white p-3 pb-0">
                        <div className="position-relative">
                            <img className="img-fluid" src={data[0]?.image_url} alt="" />
                            <div className="service-overlay">
                                <Link
                                    className="btn btn-lg-square btn-outline-light rounded-circle"
                                    to=""
                                >
                                    <i className="fa fa-link text-primary" />
                                </Link>
                            </div>
                        </div>
                        <div className="text-center p-4">
                            <h4>{data[0]?.title}</h4>
                        </div>
                    </div>
                </div>
                <div
                    className="col-lg-3 col-md-6 pt-lg-5 wow fadeInUp"
                    data-wow-delay="0.3s"
                    style={{
                        visibility: "visible",
                        animationDelay: "0.3s",
                        animationName: "fadeInUp"
                    }}
                >
                    <div className="service-item d-flex flex-column bg-white p-3 pb-0">
                        <div className="position-relative">
                            <img className="img-fluid" src={data[1]?.image_url} alt="" />
                            <div className="service-overlay">
                                <Link
                                    className="btn btn-lg-square btn-outline-light rounded-circle"
                                    to=""
                                >
                                    <i className="fa fa-link text-primary" />
                                </Link>
                            </div>
                        </div>
                        <div className="text-center p-4">
                        <h4>{data[1]?.title}</h4>
                        </div>
                    </div>
                </div>
                <div
                    className="col-lg-3 col-md-6 wow fadeInUp"
                    data-wow-delay="0.5s"
                    style={{
                        visibility: "visible",
                        animationDelay: "0.5s",
                        animationName: "fadeInUp"
                    }}
                >
                    <div className="service-item d-flex flex-column bg-white p-3 pb-0">
                        <div className="position-relative">
                            <img className="img-fluid" src={data[2]?.image_url} alt="" />
                            <div className="service-overlay">
                                <Link
                                    className="btn btn-lg-square btn-outline-light rounded-circle"
                                    to=""
                                >
                                    <i className="fa fa-link text-primary" />
                                </Link>
                            </div>
                        </div>
                        <div className="text-center p-4">
                        <h4>{data[2]?.title}</h4>
                        </div>
                    </div>
                </div>
                <div
                    className="col-lg-3 col-md-6 pt-lg-5 wow fadeInUp"
                    data-wow-delay="0.7s"
                    style={{
                        visibility: "visible",
                        animationDelay: "0.7s",
                        animationName: "fadeInUp"
                    }}
                >
                    <div className="service-item d-flex flex-column bg-white p-3 pb-0">
                        <div className="position-relative">
                            <img className="img-fluid" src={data[3]?.image_url} alt="" />
                            <div className="service-overlay">
                                <Link
                                    className="btn btn-lg-square btn-outline-light rounded-circle"
                                    to=""
                                >
                                    <i className="fa fa-link text-primary" />
                                </Link>
                            </div>
                        </div>
                        <div className="text-center p-4">
                        <h4>{data[3]?.title}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ServiceSection
